<!--
  Copyright 2024 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="page">
  <ground-header></ground-header>

  <h1 class="page-title" i18n="@@app.labels.about">About</h1>

  <div class="container">
    <img class="logo" src="assets/img/logo.svg" alt="Ground logo" />

    <section i18n="@@app.texts.about.section1">Ground is an open-source community project built by Google and FAO under the Forest Data Partnership with help from SIG, Ecam, and open-source community contributors.</section>

    <section i18n="@@app.texts.about.section2">It is licensed under the <a href="https://www.apache.org/licenses/LICENSE-2.0" target="_blank">Apache License, Version 2.0</a>.</section>

    <section i18n="@@app.texts.about.section3">Copyright 2024 <a href="https://github.com/google/ground-platform/blob/master/AUTHORS" target="_blank">The Ground Authors</a></section>

    <section class="build-info">
      <span i18n="@@app.labels.version">Version</span>
      {{ buildVersion }} ({{ buildCommitId }})
    </section>

    <button
      mat-button
      color="primary"
      aria-label="back"
      class="back-button"
      (click)="onBackButtonClick()"
    >
      <mat-icon>arrow_back</mat-icon>

      <span i18n="@@app.labels.back">Back</span>
    </button>
  </div>
</div>
